import { render, staticRenderFns } from "./AssignSubjectModal.vue?vue&type=template&id=4307d0a4&scoped=true&"
import script from "./AssignSubjectModal.vue?vue&type=script&lang=js&"
export * from "./AssignSubjectModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4307d0a4",
  null
  
)

export default component.exports